<template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="general-container evaluation-page-patient-info">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar-medical-device :title="text('api.evaluation.title')" ref="headerMedical"></header-bar-medical-device>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-evaluation" ref="vLayoutScrollableRef">
            <v-layout row wrap>
                <v-flex xs12 class="evaluation-card">
                    <v-card class="component-bg-color" :class="{'border-highlighted': isPanelHighlight === true}">

                        <v-card-text v-if="evaluationData.decisionItems" class="px-0">
                            <h2>{{text('db.product.PROD_EVAL')}}</h2>
                            <div class="decision-item" v-for="evaluation in evaluationData.decisionItems">
                                <h4 v-html="evaluation.evaluationTxt" id="color-update" v-bind:style="{color: getDecisionItemColor(evaluation)}">
                                </h4>
                                <div v-if="evaluation.decisionItemType === 'UPGRADE'">
                                    {{text('api.scoring.upgrade.label')}}
                                </div>
                                <div v-if="evaluation.decisionItemType === 'NORMAL'">
                                    <div v-for="proArgument in evaluation.proArguments">

                                        <ul>
                                            <li>
                                                <span class="evaluation-argument-row">

                                                    <span v-html="proArgument.text"></span>

                                                    <span v-if="isAdmin" class="float-right">
                                                        <span class="proargument-v1-v2">{{proArgument.v1}} &nbsp;{{proArgument.v2}}</span>
                                                        <span class="proargument-v3-v4">{{proArgument.v3}} &nbsp;{{proArgument.v4}}</span>

                                                        <span class="proargument-t"><span v-if="proArgument.target === true">T</span></span>

                                                    </span>

                                                </span>


                                            </li>
                                        </ul>
                                        <p v-html="proArgument.description">
                                        </p>

                                    </div>
                                </div>
                                <div v-if="evaluation.decisionItemType === 'DOWNGRADE'">
                                    {{text('api.scoring.downgrade.label')}}
                                </div>
                            </div>
                        </v-card-text>

                        <v-card-text v-if="!evaluationData.decisionItems && !isLoadingEvaluationData">
                            <h2>{{text('db.product.PROD_EVAL')}}</h2>
                            <div>{{text("api.evaluation.noDecision")}}</div>
                        </v-card-text>

                    </v-card>


                </v-flex>
            </v-layout>
            </div>
        </v-container>

        <v-footer app class="elevation-bg-color border-top-invisible">
            <v-layout row wrap class="padding-left-xxl padding-right-xxl">
                <v-flex text-xs-center>

                    <div class="footer-right-btns">
                        <v-btn flat @click="goToPreviousPage" class="footer-btn">
                            <arrow-left-icon />
                            {{ text('api.button.back') }}
                        </v-btn>
                        <v-btn v-if="evaluationData.hasScoringData" @click="goToNextPage" class="footer-btn footer-btn-next color-on-primary-text" color="primary">
                            {{ text('api.button.next') }}
                            <arrow-next-icon :svg-fill-class="'svg-on-primary-color'"/>
                        </v-btn>
                    </div>

                </v-flex>
            </v-layout>
        </v-footer>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import HeaderBar from '../shared/HeaderBar';
import TopBar from '../../../common/components/shared/TopBar';
import AssessmentAlerts from "../../../common/components/shared/AssessmentAlerts";
import PatientInfo from "../../../common/components/shared/PatientInfo";
import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
import HeaderBarMedicalDevice from "../shared/HeaderBarMedicalDevice";
import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
import ArrowLeftIcon from "../../../common/components/svg/shared/arrowLeftIcon";
import ArrowNextIcon from "../../../common/components/svg/shared/arrowNextIcon";

export default {
        name: 'EvaluationPage',
        components: {
            ArrowNextIcon,
            ArrowLeftIcon,
            HeaderBar,
            TopBar,
            AssessmentAlerts,
            PatientInfo,
            AcceptCookie,
            HeaderBarMedicalDevice,
            DetectBrowserCookie
        },

        beforeCreate() {
            this.$store.commit('EvaluationStore/resetStore');
            this.$store.commit('AssessmentAlertsStore/resetStore');
        },

        created() {
            this.$store.dispatch('EvaluationStore/loadEvaluationData');
            window.addEventListener('keyup', this.handleKeyUps);
            window.addEventListener('keydown', this.handleKeyDowns);
        },

        destroyed() {
            window.removeEventListener('keyup', this.handleKeyUps);
            window.removeEventListener('keydown', this.handleKeyDowns);
        },

        data() {
            return {
                tempPatientComment: "",
                showComment: false,
                isPanelHighlight: false,

                isKeyDown: {}
            }
        },

        computed: mapGetters({
            evaluationData: 'EvaluationStore/getEvaluationData',
            patientProfileData: 'AssessmentStartStore/getPatientProfileData',
            isLoadingEvaluationData: 'EvaluationStore/getIsLoadingEvaluationData',
            getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
            isAdmin: 'UserStore/getIsAdmin',
            getIsAssessmentSealed: 'ScoringStore/getIsAssessmentSealed',
            getShowUserComment: 'TranslationStore/getShowUserComment',
            getShowUserCommentShortcut: 'TranslationStore/getShowUserCommentShortcut',
            mustShowInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
            getIsThemeDarkActive : 'TranslationStore/getIsThemeDarkActive',
            getDecisionItemColor: 'ThemeStore/getDecisionItemColor'
        }),

        methods: {
            // --------- Component methods. ---------

            setTemporaryPatientCommentValue() {
                this.tempPatientComment = this.patientProfileData.comment;

                // Place cursor at the end of the patient comment text
                let commentId = document.getElementById("comment");
                if (commentId != null) {

                    let commentLength = commentId.value.length;
                    commentId.selectionStart = commentLength;
                    commentId.selectionEnd = commentLength;
                }
            },

            isPatientCommentChanged: function () {
                return this.tempPatientComment !== this.patientProfileData.comment;
            },

            savePatientComment: function() {
                if (this.$refs.headerMedical.isPatientCommentChanged() && this.getShowUserCommentShortcut) {
                    this.$store.dispatch("AssessmentStartStore/submitPersistPatientProfileComment");
                }
                this.showComment = false;
                this.$store.commit('TranslationStore/setShowUserComment', this.showComment);
                this.$store.commit('TranslationStore/setShowUserCommentShortcut', this.showComment);
            },


            goToPreviousPage() {
                if(!this.getMustShowAssessmentList) {
                    this.$router.push('/symptoms-questions');
                } else {
                    this.$router.push('/symptoms-list');
                }

                this.$store.commit('ScoringStore/setIsAssessmentSealed', false);
            },

            goToNextPage() {
                this.$router.push('/scoring');
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            handleKeyDowns(event) {

                switch(event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Escape
                    case 27:
                        this.savePatientComment();
                        break;
                }

                if (this.getShowUserComment === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Backspace
                    case 8:
                    // Alt
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // PageUp
                    case 33:
                        event.preventDefault();
                        if (this.mustShowInfoPopup === true) {
                            return;
                        }
                        if (this.$refs["vLayoutScrollableRef"] != null) {
                                this.$refs["vLayoutScrollableRef"].scrollTop -= 50;
                            }
                        break;

                    // PageDown
                    case 34:
                        event.preventDefault();
                        if (this.mustShowInfoPopup === true) {
                            return;
                        }
                        if (this.$refs["vLayoutScrollableRef"] != null) {
                                this.$refs["vLayoutScrollableRef"].scrollTop += 50;
                            }
                        break;

                }

                //Prevent repeated calls for certain keys
                if (this.isKeyDown[event.keyCode] === true) {
                    return;
                }
                this.isKeyDown[event.keyCode] = true;

                switch(event.keyCode) {
                    // Shift
                    case 16:
                        if (this.mustShowInfoPopup === true) {
                            return;
                        }
                        // For Shift only, without other key combinations.
                        this.isPanelHighlight = true;
                        break;

                    // PageUp
                    case 33:
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            // SHIFT+PageUp : Goto previous page
                            this.goToPreviousPage();
                        }
                        break;

                    // PageDown
                    case 34:
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            // SHIFT + PageDown : Goto next page
                            this.goToNextPage();
                        }
                        break;

                    // End
                    case 35:
                        // Shift + End
                        if (event.ctrlKey === false && event.altKey === false && event.shiftKey === true) {
                            if (this.mustShowInfoPopup === true) {
                                return;
                            }
                            this.navGotoLastPage();
                        }
                        break;

                    // Home
                    case 36:
                        // Shift + Home
                        if (event.ctrlKey === false && event.altKey === false && event.shiftKey === true) {
                            if (this.mustShowInfoPopup === true) {
                                return;
                            }
                            this.navGotoFirstPage();
                        }
                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }

                            // focus on textarea comment
                            this.showComment = true;
                            this.$store.commit('TranslationStore/setShowUserComment', this.showComment);
                            this.$store.commit('TranslationStore/setShowUserCommentShortcut', this.showComment);
                        }
                        break;

                }
            },

            handleKeyUps(event) {

                this.isKeyDown[event.keyCode] = false;

                switch(event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    //Enter
                    case 13:
                        // Ctrl + Enter
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            // Close the patient comment popup on Ctrl + Enter
                            if (this.getShowUserComment === true) {
                                this.savePatientComment();
                            }
                        }
                        break;

                    // Shift
                    case 16:
                        this.isPanelHighlight = false;
                        break;
                }
            },

            navGotoFirstPage() {
                if(!this.getMustShowAssessmentList) {
                    this.$router.push('/assessment-start');
                } else {
                    this.$router.push('/assessment-start-list');
                }
            },

            navGotoLastPage() {
                // On Evaluation Page, the next page is last next page
                this.goToNextPage();
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .evaluation-card {
        margin-bottom: 25px;
        padding-top: 2px !important;

        .card {
            border-radius: 5px;
            padding: 20px 30px !important;
            min-height: 600px;

            .card__text {
                border-top: none;

                h2{
                    margin-bottom: 30px;
                    font-size: $font-size-medium;
                    padding-bottom: 10px;
                    border-bottom: 1px solid $color-gray;
                }

                > div {

                   h4 {
                       margin-bottom: 10px;
                   }

                    p {
                        margin-bottom: 5px;
                    }
                }

                .decision-item {
                    margin-bottom: 15px;
                    padding-bottom: 15px;
                    border-bottom: 1px solid $color-gray;
                }
            }
        }

    }



    .evaluation-argument-row {

        .proargument-v1-v2 {
            padding-left: 20px;
            min-width: 100px;
            display: inline-block;
            text-align: right;
            box-sizing: content-box;
        }
        .proargument-v3-v4 {
            padding-left: 40px;
            min-width: 100px;
            display: inline-block;
            box-sizing: content-box;
        }
        .proargument-t {
            padding-left: 20px;
            min-width: 30px;
            display: inline-block;
            box-sizing: content-box;
        }
    }
</style>



// WEBPACK FOOTER //
// src/professional/components/evaluation/EvaluationPage.vue